export default function VersionComponent() {
    const version = require("../../package.json").version;

    return (
        <div className="flex shadow-md rounded bg-slate-600 px-3 py-2 justify-between">
            <span className="text-sm font-semibold text-white">©Modim</span>
            <span className="text-sm font-semibold text-white">Ver. {version}</span>
        </div>
    );
}
